<template>
    <tr class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item">
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_checkbox">
            <list-table-check
                :name="`lms-superadmin-users-bulk-actions-add-to-groups-select-users-table-item-${index}`"
                :emit-list-name="'bulk-add-user-to-group-item-list-action'"
                :emit-checkbox-name="'bulk-add-user-to-group-item'"
                :key="userProfileId"
                :index="userProfileId"
                :checked="isUserSelected"
                @emit-check="performEmitCheck"
            />
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_firstname">
            <div class="columns is-vcentered">
                <div class="column">
                    {{ userFirstName }}
                </div>
            </div>
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_lastname">
            <div class="columns is-vcentered">
                <div class="column">
                    {{ userLastName }}
                </div>
            </div>
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_email">
            {{ userEmail }}
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_roles">
            <component-badge-roles-list
                v-if="userProfileRoles"
                :roles="userProfileRoles"
            ></component-badge-roles-list>
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_orgunit">
            {{ userProfileOrgUnitName }}
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_group">
            <component-text-list
                :items="userProfileGroups"
                :limit-active="true"
            ></component-text-list>
        </td>
        <td class="lms__superadmin_users_bulk_actions_add_to_groups_select_users_table_item_status">
            <component-status :status="userProfileStatus === 'cancelled' ? 'invitation-cancelled' : userProfileStatus"/>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentBadgeRole from '@/components/default/shared/ComponentBadgeRole'
import ComponentBadgeRolesList from '@/components/default/shared/ComponentBadgeRolesList'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ListTableCheck from '@/components/default/shared/ListTableCheck'

export default {
  name: 'lms-superadmin-users-bulk-actions-add-to-groups-select-users-table-item',
  components: { ListTableCheck, ComponentTextList, ComponentBadgeRolesList, ComponentBadgeRole, ComponentButtonMenu, ComponentStatus, ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    selected: {
      type: [Array, Object]
    }
  },
  computed: {
    isUserSelected () {
      const selected = this.selected
      const userProfileId = this.userProfileId

      return selected && selected.length ? selected.includes(userProfileId) : false
    },
    userProfileId () {
      return this.item.profileId
    },
    userFirstName () {
      return this.item.firstName
    },
    userLastName () {
      return this.item.lastName
    },
    userEmail () {
      return this.item.emailAddress
    },
    userProfileStatus () {
      let firstProfile
      let status

      status = this.item.profileStatus

      return status
    },
    userProfileRoles () {
      let firstProfile
      let roles

      roles = this.userRoles

      return roles
    },
    userProfileOrgUnitName () {
      const orgUnit = this.item.organisationUnit
      return orgUnit ? orgUnit.name : ''
    },
    userProfileGroups () {
      const groups = this.item.groups
      return groups ? groups.map(obj => obj.name) : []
    },
    userRoles () {
      return this.item.roles
    }
  },
  methods: {
    performEmitCheck (data) {
      data.item = this.item
      this.$emit('emit', { message: 'emit-check', value: data })
    }
  }
}
</script>
